import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import * as firebase from 'firebase';

import LinearProgress from 'material-ui/LinearProgress';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import TextField from 'material-ui/TextField';

import Fetcher from '../../util/fetcher';
import ErrorDialog from '../ErrorDialog';
import StepProps from '../../constants/StepProps';
import getConfig from '../../config';

const fileDownloadIcon = <FontIcon className="material-icons">file_download</FontIcon>;
const copyIcon = <FontIcon className="material-icons">content_copy</FontIcon>;

const styles = {
  centeredText: {
    textAlign: 'center',
  },
}

const MyStepProps = Object.assign({}, StepProps);

MyStepProps.hash = MyStepProps.hash.isRequired
MyStepProps.onStepCompleteSuccess = MyStepProps.onStepCompleteSuccess.isRequired

class AmplificationResults extends Component {
  static contextTypes = {
    dataset: PropTypes.string.isRequired,
    datasetLocation: PropTypes.string.isRequired,
    firebaseToken: PropTypes.string.isRequired,
  };

  static propTypes = MyStepProps;

  constructor(props, context) {
    super(props, context);
    this.state = {
      busy: true,
      downloadLink: '',
      errorMessage: '',
    }
    this.config = getConfig();
  }

  componentDidMount() {
    this.startExport();
  }

  /**
   * Send the process load request. Once succesfully finished, keep querying `process/status` to see when the
   * amplification job has finished.
   */
  startExport = () => {
    const { hash } = this.props;

    Fetcher.init(this.context.firebaseToken)
      .ampSave(hash, this.context.dataset)
      .then(this.delayedPollStatus)
      .catch(this.processFailed);
  }

  /**
   * When an error occurs, let the user know.
   * @param {Object} error
   */
  processFailed = (error) => {
    this.setState({
      busy: false,
      errorMessage: 'There might a problem with your download. Please contact us if this problem persists.',
    });
    // OK. weird to call success here, but this will mark the wizard as finished
    this.props.onStepCompleteSuccess();
  }

  /**
   * Delayed call to export status poll
   *
   * @param {Object} response
   */
  delayedPollStatus = (response) => {
    // Here we check if the pollStatus should be called again, or if we are finished:
    if (response.data.done) {
      this.processExportCompleted();
    } else {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.pollStatus, 5000);
    }
  }

  /**
   * When the load has succesfully completed, we should keep monitoring the BQ job that does the amplification.
   * We do this by polling.
   *
   * @param {Object} response
   */
  pollStatus = () => {
    const { hash } = this.props;

    Fetcher.init(this.context.firebaseToken)
      .ampSaveStatus(hash, this.context.dataset)
      .then(this.delayedPollStatus)
      .catch(this.processFailed);
  }

  copyLinkToClipboard = () => {
    copy(this.state.downloadLink);
  }

  /**
   * When we are done with export process, fetch the download link
   */
  processExportCompleted = () => {
    const { hash } = this.props;

    // get the right bucket
    let storage = firebase.app().storage(this.config.buckets[this.context.datasetLocation]);

    // find the file on the bucket and generate a download link
    storage.ref()
      .child(`amp/${this.context.dataset}/amplified/${hash}.csv`)
      .getDownloadURL()
      .then(this.fetchDownloadLink)
      .catch(this.processFailed);
  }

  /**
   * After fetching the download link, show the download button.
   */
  fetchDownloadLink = (url) => {
    this.setState({
      busy: false,
      downloadLink: url,
    });
    this.props.onStepCompleteSuccess();
  }

  render() {
    const {busy, errorMessage} = this.state;
    return (
      busy ?
      <div>
        <br />
        <p>Your data is being prepared for download. This can take up to a minute.</p>
        <LinearProgress mode="indeterminate" />
        <br />
        <br />
      </div>
      :
      <div style={styles.centeredText}>
        <p>Your amplified audience is ready to download. The link below will expire after one hour.</p>
        <TextField
          value={this.state.downloadLink}
          floatingLabelText="Download link"
        />
        <IconButton tooltip="Copy to clipboard" onTouchTap={this.copyLinkToClipboard}>
          {copyIcon}
        </IconButton>
        <br/><br/>
        <RaisedButton
          label="Download amplified audience"
          icon={fileDownloadIcon}
          primary={true}
          href={this.state.downloadLink}
        />
        <br/><br/>
        <ErrorDialog message={errorMessage} onRequestClose={()=>this.setState({errorMessage:''})} />
      </div>
    );
  }

}

export default AmplificationResults



// WEBPACK FOOTER //
// ./src/components/AmpStepExport/index.jsx